module.exports = __webpack_public_path__ + "Roboto-BoldItalic.a7dce23c0dd99a4afa5c.woff";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.woff
// module chunks = 5